import(/* webpackMode: "eager" */ "/vercel/path0/app/interviews/error.tsx");
